import React, { useEffect, useState } from 'react'
import { Text } from '../../../core-components'
import { getCurrentTime } from './helpers'

type Props = {
  locale?: string
  timezone: string
}

export const CurrentTimeDisplay = ({ locale = 'en-US', timezone }: Props) => {
  const [currentTime, setCurrentTime] = useState<string>(
    getCurrentTime(new Date(), locale, timezone)
  )

  useEffect(() => {
    const updateCurrentTime = () => {
      setCurrentTime(getCurrentTime(new Date(), locale, timezone))
    }

    updateCurrentTime()

    const intervalId = window.setInterval(() => {
      updateCurrentTime()
    }, 1000)

    return () => {
      window.clearInterval(intervalId)
    }
  }, [locale, timezone])

  return (
    <Text color='fg/moderate' display='block' textStyle='item-unselected'>
      {currentTime}
    </Text>
  )
}
